import { Box, List, ListItem, ListItemText, Typography } from "@mui/material";
import { MessageNotification } from "../../../_components/box/message-notification";
import type { AnnualCatalogueItemRow, BasketHistoryEntry } from "./auction-annual-shared";

interface AuctionAnnualBasketHistoryListProps {
    history: BasketHistoryEntry[];
    catalogueItemsById: Map<number, AnnualCatalogueItemRow>;
    emptyMessage?: string;
}

export function AuctionAnnualBasketHistoryList({
    history,
    catalogueItemsById,
    emptyMessage = "No basket history yet.",
}: AuctionAnnualBasketHistoryListProps) {
    if (history.length === 0) {
        return <MessageNotification message={emptyMessage} />;
    }

    return (
        <List disablePadding>
            {history.map((entry, idx) => {
                const entryItems = entry.itemIds.map((id) => {
                    const row = catalogueItemsById.get(id);
                    return {
                        key: `${entry.roundNumber}-${id}`,
                        label: `Lot ${row?.lotNo ?? id} • BAU ${row?.forestCode ?? "—"} • ${row?.product ?? "Unknown"} • Vol ${row?.totalVolume ?? 0}`,
                    };
                });
                return (
                    <ListItem key={`${entry.roundNumber}-${idx}`} disablePadding sx={{ py: 0.5 }}>
                        <ListItemText
                            primaryTypographyProps={{ variant: "subtitle1" }}
                            primary={
                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontWeight: 700,
                                            px: 1,
                                            py: 0.25,
                                            borderRadius: 1,
                                            backgroundColor: "action.selected",
                                        }}
                                    >
                                        Round {entry.roundNumber}
                                    </Typography>
                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                        {entry.itemIds.length} item(s)
                                    </Typography>
                                </Box>
                            }
                            secondary={
                                <Box sx={{ mt: 0.25 }}>
                                    <Typography variant="body1" color="text.secondary" display="block">
                                        Used: {entry.used} • Allowance: {entry.allowance} • Left: {entry.remaining}
                                    </Typography>
                                    {entryItems.length > 0 ? (
                                        <Box sx={{ mt: 0.5, display: "grid", gap: 0.25 }}>
                                            {entryItems.map((item) => (
                                                <Typography key={item.key} variant="body1" color="text.secondary" display="block">
                                                    {item.label}
                                                </Typography>
                                            ))}
                                        </Box>
                                    ) : (
                                        <Typography variant="body1" color="text.secondary" display="block">
                                            Items: None
                                        </Typography>
                                    )}
                                </Box>
                            }
                        />
                    </ListItem>
                );
            })}
        </List>
    );
}
